/**
 * ユーザーメッセージコンポーネント
 */

import { UserIcon } from '@/components/icons/UserIcon';
import { MessageBubble } from '@/components/message/MessageBubble';
import { AttachedFileInfo } from '@/types';

interface UserMessageProps {
  text: string;
  attachedFiles?: AttachedFileInfo[];
}

export const UserMessage = ({ text, attachedFiles }: UserMessageProps) => (
  <MessageBubble role="user" content={text} avatar={<UserIcon />} attachedFiles={attachedFiles} />
);
